import { render, staticRenderFns } from "./ScheduleTrialWithJudicialCaseManager.vue?vue&type=template&id=2ef09164"
import script from "./ScheduleTrialWithJudicialCaseManager.vue?vue&type=script&lang=ts"
export * from "./ScheduleTrialWithJudicialCaseManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports